export default __webpack_public_path__ + "static/media/FoxNews.d34f3466.svg";